module.exports = __webpack_public_path__ + "img/overtime-empty-img.9ccafcff.png";